import { activeFacebookPageSelector } from 'packages/state/selectors/facebookPageSelector';
import { landmineNames } from '@mm/constants/landmine-names';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useFreeTrialUpgradeModal } from './common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import moment from 'moment';
import { IS_PROD_URL } from '@mm/utils';
import { isAnyModalOpen } from '@mm/state/selectors/modalSelector';
import { INewBillingModal2023Props } from '@mm/state/modules/modalsState/props';

const key = 'free_trial_upgrade_promo_last_seen';

export const useSubscribeFromTrialPromoModal = (
  modalProps?: INewBillingModal2023Props,
) => {
  const modal = useFreeTrialUpgradeModal();
  const isAnyModalOpened = useSelector(isAnyModalOpen);
  const activeCompany = useSelector(activeCompanySelector);
  const facebookPage = useSelector(activeFacebookPageSelector);

  useEffect(() => {
    if (modal.isFreeTrialPromotionWithoutSubscription) {
      const time = localStorage.getItem(key);

      if (
        (time &&
          moment().diff(
            moment(parseInt(time, 10)),
            IS_PROD_URL ? 'hours' : 'minutes',
          ) < 12) ||
        activeCompany?.bookAnEnterprise ||
        isAnyModalOpened ||
        facebookPage?.subscription
      ) {
        return;
      }

      localStorage.setItem(key, moment.now().toString());
      if (time) {
        modal.openFreeTrialUpgradeModalPromotional({
          ...modalProps,
          landmineName:
            modalProps?.landmineName ||
            landmineNames.SUBSCRIBE_FROM_TRIAL_PROMO,
        });
      }
    }
  }, [
    modal.isFreeTrialPromotionActive,
    activeCompany?.bookAnEnterprise,
    isAnyModalOpened,
  ]);
};
